<template>
  <AppDialog
    key="insights-collaboration-data-lag"
    append-to-body
    :show="show"
    size="smedium"
    position="centered"
    title="How your data updates"
    class="insights-collaboration-data-lag-dialog"
    @close="closeDialog"
  >
    <p>Each integration reports on its own schedule, so the most recent days can look lower than they really are.</p>
    <p>
      Microsoft is the slowest: activity from <strong>today</strong> only lands in this widget
      <strong>3 days from now</strong>. All dates and times are shown in UTC.
    </p>

    <table class="data-lag-table">
      <thead>
        <tr>
          <th>Integration</th>
          <th>Updates</th>
          <th>Delay</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="provider in providers"
          :key="provider.name"
        >
          <td>
            <img
              class="provider-logo"
              :src="provider.logo.src"
              :alt="provider.logo.alt"
            />
            <strong>{{ provider.name }}</strong>
          </td>
          <td>{{ provider.updates }}</td>
          <td>
            <span :class="['delay-badge', { 'no-delay': provider.noDelay }]">{{ provider.delay }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="text-right mt-30">
      <AppButton
        type="primary"
        @click="closeDialog"
      >
        Got it
      </AppButton>
    </div>
  </AppDialog>
</template>

<script>
import { INSIGHTS_ASSETS } from '~/app_constants';
import AppButton from '~/components/AppButton.vue';
import AppDialog from '~/components/AppDialog.vue';

export default {
  name: 'InsightsCollaborationDataLagDialog',
  components: {
    AppDialog,
    AppButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  data: () => ({
    providers: Object.freeze([
      {
        name: 'Microsoft',
        logo: INSIGHTS_ASSETS.collaboration_provider_logos.microsoft_collab,
        updates: 'Daily',
        delay: '3-day delay',
      },
      {
        name: 'Google',
        logo: INSIGHTS_ASSETS.collaboration_provider_logos.google_collab,
        updates: 'Daily',
        delay: '1-day delay',
      },
      {
        name: 'Slack',
        logo: INSIGHTS_ASSETS.collaboration_provider_logos.slack_collab,
        updates: 'Instant',
        delay: 'No delay',
        noDelay: true,
      },
    ]),
  }),
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
